import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
function ColorIndicator1D({ color, activated }) {
    return (_jsx("div", { style: {
            backgroundColor: color,
            height: '12px',
            width: '12px',
            opacity: activated ? 1 : 0.2,
            display: 'inline-block',
        } }));
}
function ColorIndicator2D({ positiveColor, negativeColor, activated, }) {
    return (_jsx("svg", { width: "12", height: "12", viewBox: "0 0 12 12", opacity: activated ? 1 : 0.2, children: _jsxs("g", { children: [_jsx("path", { d: "M0,0H12L0,12Z", fill: positiveColor, strokeWidth: "0" }), _jsx("path", { d: "M12,12H0L12,0Z", fill: negativeColor, strokeWidth: "0" })] }) }));
}
function ColorIndicator(props) {
    const { style, onClick = () => null, activated, dimension, color } = props;
    return (_jsx("button", { style: style, type: "button", onClick: onClick, children: dimension === 2 ? (_jsx(ColorIndicator2D, { ...color, activated: activated })) : (_jsx(ColorIndicator1D, { activated: activated, ...color })) }));
}
export default memo(ColorIndicator);
